import template from './login.html';
import './login.scss';

export class LoginController {
  constructor($scope) {
    'ngInject';

    this.$scope = $scope;

    this.credentials = {
      email: '',
      password: '',
    };

    this.errorMessage = '';
  }
  $onChanges({ error }) {
    if (error && error.currentValue) {
      this.errorMessage = error.currentValue;
    }
  }
  login() {
    if (!this.loading) {
      const { form } = this;
      if (form.$valid) {
        this.errorMessage = '';
        this.onLogin(this.credentials);
      } else if (form.$error.email) {
        this.errorMessage = 'Please enter a valid e-mail address';
      } else {
        this.errorMessage = 'Please complete the form';
      }
    }
  }
  get form() {
    return this.$scope.nzLoginBox_form;
  }
}

export default {
  controller: LoginController,
  template,
  bindings: {
    error: '<',
    loading: '<',
    onLogin: '&',
    forgotPasswordUrl: '<',
    privacyPolicyUrl: '<',
  },
};
